import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagMG = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#6DA544",
  d: "M16.304 24.999v23.445A24.943 24.943 0 0 0 25 49.999c13.807 0 25-11.193 25-25s-33.696 0-33.696 0Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M25 0c-3.058 0-5.988.55-8.696 1.555V25H50C50 11.193 38.807 0 25 0Z"
}));
FlagMG.displayName = 'FlagMG';
export default withFlagWrapper(FlagMG);
//# sourceMappingURL=index.js.map